import logger from '~/services/logger';

export function setupMockDateOnce(
  isMock: boolean,
  mockDate: string,
  isMockModeInitializedRef: React.MutableRefObject<boolean>
) {
  if (isMock && !isMockModeInitializedRef.current) {
    const fakeNow = new Date(mockDate).valueOf();

    // Extend Date constructor to default to fakeNow
    // eslint-disable-next-line no-global-assign
    const OriginalDate = globalThis.Date;

    globalThis.Date = new Proxy(OriginalDate, {
      construct(target, args) {
        if (args.length === 0) {
          return new target(fakeNow);
        }
        return new target(
          ...(args as unknown as [
            number,
            number,
            number,
            number?,
            number?,
            number?,
            number?
          ])
        );
      },
    }) as DateConstructor;

    // Override Date.now() to start from fakeNow
    const __DateNowOffset = fakeNow - Date.now();
    const __DateNow = Date.now;
    Date.now = () => __DateNow() + __DateNowOffset;

    isMockModeInitializedRef.current = true;
  }
}

/**
 * Converts a Date object to an ISO date string.
 * @param date The Date object to convert. Defaults to the current date and time.
 * @returns The ISO date string representation of the given date.
 */
export function getIsoDateString(date: Date = new Date()): string {
  return date.toISOString();
}

/**
 * Normalizes an ISO date to the top of the hour in ISO format.
 * @param input the input object.
 * @param input.isoDate the ISO date to normalize.
 * @returns the normalized ISO date string.
 */
export function getNormalizedEpgDateTime({
  isoDate,
}: {
  isoDate: string;
}): string {
  try {
    const baseDate = new Date(isoDate);

    if (Number.isNaN(baseDate.getTime())) {
      throw new Error('Invalid ISO date');
    }

    return new Date(baseDate.setMinutes(0, 0, 0)).toISOString();
  } catch (error: unknown) {
    logger.error(`getNormalizedEpgDateTime: ${String(error)}`);
    return new Date().toISOString();
  }
}
